export enum RegisterMode {
  OPEN_KORPO = 'OPEN_KORPO',
  EXT_TRANSFER_KORPO = 'EXT_TRANSFER_KORPO',
  PPE_TRANSFER_PAYMENT_KORPO = 'PPE_TRANSFER_PAYMENT_KORPO',
  OPEN = 'OPEN',
  TRANSFER = 'TRANSFER',
  PPE_TRANSFER_PAYMENT = 'PPE_TRANSFER_PAYMENT',
}

export const isKorpoRegisterMode = (value: RegisterMode): boolean => {
  return [
    RegisterMode.OPEN_KORPO,
    RegisterMode.EXT_TRANSFER_KORPO,
    RegisterMode.PPE_TRANSFER_PAYMENT_KORPO,
  ].includes(value);
};

export const isTransferRegisterMode = (value: RegisterMode): boolean => {
  return [
    RegisterMode.TRANSFER,
    RegisterMode.EXT_TRANSFER_KORPO,
    RegisterMode.PPE_TRANSFER_PAYMENT,
    RegisterMode.PPE_TRANSFER_PAYMENT_KORPO,
  ].includes(value);
};

export const isPpeTransferRegisterMode = (value: RegisterMode): boolean => {
  return [
    RegisterMode.PPE_TRANSFER_PAYMENT,
    RegisterMode.PPE_TRANSFER_PAYMENT_KORPO,
  ].includes(value);
};
